import React, { useState } from 'react';
import { toast } from 'react-toastify';
import DefaultModal from 'components/Modal/DefaultModal';
import { Row, Col, FormGroup, Label, Input } from 'reactstrap';
import ReactButton from 'components/Buttons/ReactButton';
import ReactLoader from 'components/Loader';

const ImportContactsToDialerModal = ({
  buttonOpenModal,
  dialerId,
  importToDialerService,
  callback
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
  };

  const handleImport = async () => {
    if (!file) {
      toast.error('Selecione um arquivo para importar');
      return;
    }

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append('file', file);

      await importToDialerService(formData);

      toast.success('Contatos importados com sucesso');
      setIsModalOpen(false);
      if (callback) callback();
    } catch (error) {
      console.error('Erro ao importar contatos:', error);
      toast.error(
        error.response?.data?.message ||
          'Erro ao importar contatos. Tente novamente.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {buttonOpenModal({ onClick: () => setIsModalOpen(true) })}

      <DefaultModal
        show={isModalOpen}
        onModalToggle={setIsModalOpen}
        title="Importar Contatos"
        showCloseButton={false}
      >
        {loading ? (
          <Row className="justify-content-md-center py-4">
            <ReactLoader />
          </Row>
        ) : (
          <>
            <Row>
              <Col>
                <FormGroup>
                  <Label for="file">Selecione o arquivo CSV ou XLSX</Label>
                  <Input
                    type="file"
                    name="file"
                    id="file"
                    accept=".csv,.xlsx"
                    onChange={handleFileChange}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <p className="small text-muted">
                  O arquivo deve conter as colunas: nome, telefone, email
                  (opcional)
                </p>
              </Col>
            </Row>
            <Row>
              <Col className="d-flex justify-content-end">
                <ReactButton
                  btnColor="secondary"
                  type="button"
                  size="sm"
                  onClick={() => setIsModalOpen(false)}
                  className="mr-2"
                >
                  Cancelar
                </ReactButton>
                <ReactButton
                  btnColor="confirmation"
                  type="button"
                  size="sm"
                  onClick={handleImport}
                  disabled={!file}
                >
                  Importar
                </ReactButton>
              </Col>
            </Row>
          </>
        )}
      </DefaultModal>
    </>
  );
};

export default ImportContactsToDialerModal;
